import { Injectable } from '@angular/core';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {BASE_URL_SERVER} from "../../../environments/environment";
import {BookingPaymentStatistic} from "./money/money.component";
import {TopPayers} from "./top-payers/top-payers.component";

@Injectable({
  providedIn: 'root'
})
export class StatisticService {
  constructor(
    private http: HttpClient
  ) {
  }

  findPaymentStatistic(from: Date, to: Date): Observable<HttpResponse<BookingPaymentStatistic>> {
    return this.http.get<BookingPaymentStatistic>(`${BASE_URL_SERVER}/admin-panel/statistic/booking/money?from=${from.toISOString()}&to=${to.toISOString()}`,
      {observe: 'response'});
  }

  findParentTopPayersStatistic(from: Date, to: Date): Observable<HttpResponse<TopPayers[]>> {
    return this.http.get<TopPayers[]>(`${BASE_URL_SERVER}/admin-panel/statistic/parent?from=${from.toISOString()}&to=${to.toISOString()}`,
      {observe: 'response'});
  }
}
